import React from "react";

export const UserContext = React.createContext({
    loginIn: false,
    setLoginIn: (e) => {}
});

export default UserContext;
